import { trigger, state, style, animate, transition, } from '@angular/core';
export var translateInOut = trigger('transition', [
    state('*', style({ transform: 'translateY(0)' })),
    state('void', style({ transform: 'translateY(0)' })),
    state('bottomOut', style({ transform: 'translateY(100%)' })),
    state('topOut', style({ transform: 'translateY(-100%)' })),
    transition('void => topIn', [
        style({ transform: 'translateY(-100%)' }),
        animate('1000ms ease-in-out'),
    ]),
    transition('void => bottomIn', [
        style({ transform: 'translateY(100%)' }),
        animate('1000ms ease-in-out'),
    ]),
    transition('* => *', animate('1000ms ease-out')),
]);
//# sourceMappingURL=animations.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-cookie-law/lib/animations.js
// module id = null
// module chunks = 